import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import ToolList from "./components/ToolList";
import ScrollToTop from "./components/ScrollToTop";
import SslScan from "./pages/SslScan";
import DnsScan from "./pages/DNSScan";
import HomePage from "./pages/Home";
import BlacklistScan from "./pages/blackListScan";
import CookieScan from "./pages/CookieScan";
import MailServerScan from "./pages/MailServerScan";
import PrivacyPolicyScan from "./pages/PrivacyPolicyScan";
import TOSScan from "./pages/TOSScan";
import GDPRScan from "./pages/GDPRScan";
import PentesterScan from "./pages/PentesterScan";
import AttackSurfaceMapper from "./pages/AttackSurfaceMapper";
import FreeToolsDetails from "./pages/FreeToolsDetails";
import PortendWidgetIframe from "./pages/TestWidget";
import { Helmet } from "react-helmet-async";



const tools = [
  { name: "SSL Certificate Checker", icon: "gala:secure", route: "/sslcheck", description: "This free online tool conducts an in-depth analysis of the configuration of any SSL certificate" },
  { name: "Blacklist Checker", icon: "tdesign:system-blocked", route: "/blacklistcheck", description: "This free online tool scans the provided email domain or IP against all major IP and email blacklists" },
  { name: "DNS Checker", route: "/dnscheck", icon: "eos-icons:dns", description: "This free online tool scans the domain's servers for common DNS issues, providing a report with ways to resolve them" },
  { name: "Cookie Scanner", icon: "fluent:cookies-16-regular", route: "/cookiescanner", description: "This free online tool scans the cookies used on the website and generates a report. It also reviews GDPR and CCPA compliance needs" },
  { name: "Mail Server Checker", icon: "lucide:mail-check", route: "/mailservercheck", description: "This free online tool checks mail server configuration and security. It also checks for SPF and DKIM keys" },
  { name: "Privacy Policy Grader", icon: "arcticons:selfprivacy", route: "/privacypolicycheck", description: "This free online tool reviews the privacy policy document and identifies what is missing and what is improper in it" },
  { name: "GDPR DPA Grader", icon: "tabler:user-shield", route: "/gdprcheck", description: "This free online tool reviews the GDPR DPA document and identifies what is missing and what is improper in it" },
  { name: "Terms of Service Grader", icon: "hugeicons:court-law", route: "/toscheck", description: "This free online tool reviews the TOS document and identifies what is missing and what is improper in it" },
];

const categorizedTools = {
  Cybersecurity: [
    { name: "SSL Certificate Checker", icon: "gala:secure", route: "/sslcheck", description: "This free online tool conducts an in-depth analysis of the configuration of any SSL certificate" },
    { name: "DNS Checker", route: "/dnscheck", icon: "eos-icons:dns", description: "This free online tool scans the domain's servers for common DNS issues, providing a report with ways to resolve them" },
    { name: "Mail Server Checker", icon: "lucide:mail-check", route: "/mailservercheck", description: "This free online tool checks mail server configuration and security. It also checks for SPF and DKIM keys" },
    { name: "Pen Tester", icon: "fluent-mdl2:test-parameter", route: "/pentester", description: "This free online tool performs a Penetration Test on your website and generates a report with all the vulnerabilities found" },
    { name: "Attack Surface Mapper", icon: "ix:radarchart", route: "/attacksurfacemapper", description: "This free online tool scans your digital infrastructure. See what all is visible externally" },

  ],
  Compliance: [
    { name: "GDPR DPA Grader", icon: "tabler:user-shield", route: "/gdprcheck", description: "This free online tool reviews the GDPR DPA document and identifies what is missing and what is improper in it" },
    { name: "Privacy Policy Grader", icon: "arcticons:selfprivacy", route: "/privacypolicycheck", description: "This free online tool reviews the privacy policy document and identifies what is missing and what is improper in it" },
    { name: "Terms of Service Grader", icon: "hugeicons:court-law", route: "/toscheck", description: "This free online tool reviews the TOS document and identifies what is missing and what is improper in it" },
    { name: "Cookie Scanner", icon: "fluent:cookies-16-regular", route: "/cookiescanner", description: "This free online tool scans the cookies used on the website and generates a report. It also reviews GDPR and CCPA compliance needs" },
  ],
  Reputation: [
    { name: "Blacklist Checker", icon: "tdesign:system-blocked", route: "/blacklistcheck", description: "This free online tool scans the provided email domain or IP against all major IP and email blacklists" },
  ]
};
// Dynamic SEO
function SEOUpdater() {
  const location = useLocation();
  const tool = tools.find((t) => t.route === location.pathname);

  return (
    <Helmet>
      <title>{tool ? `${tool.name} - Portend` : "Portend Security Tools"}</title>
      <meta name="description" content={tool ? tool.description : "Explore a collection of security tools for scanning and auditing your website."} />
    </Helmet>
  );
}

function AppContent() {
  const location = useLocation();
  const hideToolList = (location.pathname === "/testwidget" || location.pathname === "/testwidget1" || location.pathname === "/testwidget2");

  return (
    <>
      <ScrollToTop />
      {!hideToolList && <NavBar />}
      <SEOUpdater />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/sslcheck" element={<SslScan />} />
        <Route path="/dnscheck" element={<DnsScan />} />
        <Route path="/blacklistcheck" element={<BlacklistScan />} />
        <Route path="/mailservercheck" element={<MailServerScan />} />
        <Route path="/cookiescanner" element={<CookieScan />} />
        <Route path="/privacypolicycheck" element={<PrivacyPolicyScan />} />
        <Route path="/pentester" element={<PentesterScan />} />
        <Route path="/gdprcheck" element={<GDPRScan />} />
        <Route path="/toscheck" element={<TOSScan />} />
        <Route path="/attacksurfacemapper" element={<AttackSurfaceMapper />} />
        <Route path="/:type/:id" element={<FreeToolsDetails />} />
      </Routes>
      {!hideToolList && <ToolList categorizedTools={categorizedTools} />}
      {!hideToolList && <Footer />}
    </>
  );
}

export default AppContent;
